<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/sp1.png" class="steps step1" v-if="status==1">
			<img src="../../assets/images/sp2.png" class="steps step2" v-if="status==2">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互_new'},{title:'日清计划详情'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>计划详情</h1>
                                </div>
                                <div class="h-pieceCon2 ljjtablehuanhang" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="dailyPlan"
                                            stripe
											border
                                            style="width: 100%"
                                    >
                                        <el-table-column
                                                width="170"
                                                prop="customerName"
                                                label="客户名称">
                                        </el-table-column>
                                        <el-table-column
                                                width="120"
                                                prop="visitDate"
                                                label="拜访时间"
                                                >
                                        </el-table-column>
                                        <el-table-column
                                                width="360"
                                                prop="visitContent"
                                                label="拜访内容">
                                          <template slot-scope="scope">
                                            <pre align="left">{{scope.row.visitContent}}</pre>
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                                width="130"
                                                prop="planUserName"
                                                label="提报人"
                                                >
                                        </el-table-column>
                                      <el-table-column
                                          width="150"
                                          prop="planUserCode"
                                          label="提报人编码"
                                      >
                                      </el-table-column>
                                        <el-table-column
                                                width="166"
                                                prop="planCreateTime"
                                                label="计划创建时间"
                                        >
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>日清详情</h1>
                                </div>
                                <div class="h-pieceCon2 ljjtablehuanhang" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="dailyPlan"
                                            stripe
											border
                                            style="width: 100%"
                                    >

                                        <el-table-column
                                            width="80"
                                                prop="isProject"
                                                label="是否项目"
                                                >
                                        </el-table-column>
                                      <el-table-column
                                          width="120"
                                          prop="projectCode"
                                          label="项目编码"
                                      >
                                      </el-table-column>
                                      <el-table-column
                                          width="160"
                                          prop="projectName"
                                          label="项目名称"
                                      >
                                      </el-table-column>
                                        <el-table-column
                                            width="360"
                                                prop="dailyContent"
                                                label="日清内容"
                                                >
                                        </el-table-column>
                                        <el-table-column
                                                prop="dailyUpdateTime"
                                                width="160"
                                                label="日清更新时间">
                                        </el-table-column>
                                        <el-table-column
                                                prop="comment"
                                                width="180"
                                                label="亮点及评价">
                                        </el-table-column>
                                      <el-table-column
                                          prop="sysScore"
                                          width="120"
                                          label="系统评分">
                                      </el-table-column>
                                    </el-table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="h-txtCenter h-mrt60" style="margin-bottom:40px;">
            <div class="apprButton">
                <el-row>
                    <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgwhite el-button--default"
                               @click="cancelRq">返回
                    </el-button>
                    <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="pass">
                        提交
                    </el-button>
                </el-row>
            </div>
            <el-button v-if="!zstype" @click="cancelRq" class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default">
                返回
            </el-button>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService';

    export default {
        data() {
            return {
                showOrhide:false,
                status:1,
                checked:true,
                toshow:"persentation2",
                textarea: '',
                q: {},
                zstype: false,
                dailyPlan: [],
            }
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/dailyPlan' && from.path == '/dailyPlanDetail'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            //查询日清计划明细
            query() {
                //查看详情
                if (this.$route.query.rqId) {
                    this.q.id = this.$route.query.rqId;
                }
                if (this.$route.query.ywid) {
                    this.q.id = this.$route.query.ywid;
                }
                if (this.$route.query.taskstatus == 0) {
                    this.zstype = true;
                }
                ss.DailyPlan.getDailyPlan(this.q).then(rd => {
                    this.dailyPlan.push(rd.msg);
                })
            },

          //取消按钮
          cancelRq() {
            this.$router.back();
          },

            closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
				if(this.status ==1){
						this.status = 2;
						document.documentElement.scrollTop = 7600;
				}else if(this.status ==2){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			}
        },
        mounted() {
            this.query();
        },
		created() {
			//this.showzhezhao()
		}

    }
</script>
<style>
    .textresize .el-textarea .el-textarea__inner {
        resize: none;
        height: 150px;
    }

    .active {
        color: red;
    }

    .Yijian .h-formbLine .el-form-item__label {
        width: 19%;
    }
	.ljjtablehuanhang .el-table td .cell{
		white-space: normal;
	}
</style>
<style scoped>


    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }

    .pinfen {
        color: #656565;
        font-size: 16px;
        margin-left: 20px;
        padding: 0 0 30px 0;
    }

    /* .pinfen .pinfenss{
        color:#087ae7;
        font-size:30px;
        font-weight:bold;

    }
    .pinfen .pinfenss.active{
        color: #ff2424;
    } */
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 1.75rem;
			left: 3rem;
			width:15.7rem;
			height: 4.5rem;
		}
		.step2{
			top: 7.05rem;
			right: 4.35rem;
			width: 4rem;
			height: 0.95rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
